export { App as default } from '@guiker/payment-main-mfe'
